export default "__VITE_ASSET__E4SQj6xr__"